import {IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {useState} from "react";
import {Delete, Edit, MoreVert} from "@mui/icons-material";

export default function ({onUpdate, onDelete}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = e => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleDelete = () => {
        onDelete();
        handleClose();
    }

    const handleUpdate = () => {
        onUpdate();
        handleClose();
    }

    return (
        <>
            <IconButton
                aria-controls={open ? "insurance-quotation-item-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                data-test="insurance-quotation-item-option"
            >
                <MoreVert/>
            </IconButton>
            <Menu
                id="insurance-quotation-item-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{"aria-labelledby": "insurance-quotation-item-option"}}
            >
                <MenuItem onClick={handleUpdate} data-test="insurance-quotation-item-option-update">
                    <ListItemIcon>
                        <Edit fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Modifier</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleDelete} data-test="insurance-quotation-item-option-delete">
                    <ListItemIcon>
                        <Delete fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Supprimer</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}
